import _ from "underscore";

// Store
import store from "../redux/store";

const fetchAllApplications = () => {
  const storeObj = store.getState();
  const { appConfig } = storeObj.appConfig;
  return appConfig.APPLICATIONS;
};

const fetchPagesByAppId = (appUID) => {
  const allApplications = fetchAllApplications();
  const pagesByAppID = _.filter(
    allApplications,
    (application) => application._uid === appUID
  )[0];
  return pagesByAppID?.PAGES;
};

const fetchComponentsByPageId = (appUID, pageUID) => {
  const allPages = fetchPagesByAppId(appUID);
  const componentsByPageId = _.filter(
    allPages,
    (page) => page._uid === pageUID
  )[0];
  return componentsByPageId?.COMPONENTS;
};

const fetchCurrentEnvironment = () => {
  const storeObj = store.getState();
  const { appConfig } = storeObj.appConfig;
  const allEnviornments = appConfig?.ENVIRONMENT[0];

  let tempEnv = [];

  Object.entries(allEnviornments).map(([key, value]) => {
    if (key === document.location.hostname) {
      tempEnv.push(value);
    }
  });
  return tempEnv[0];
};

export default {
  fetchAllApplications,
  fetchPagesByAppId,
  fetchComponentsByPageId,
  fetchCurrentEnvironment,
};
